import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]
  static values = { choiceMaximum: Number }

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.toggleSubmitButton()
    }
  }

  toggleSubmitButton() {
    const selected = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    const disabled = selected < 1 || selected > this.choiceMaximumValue

    this.submitButtonTarget.disabled = disabled
    this.submitButtonTarget.classList.toggle("disabled", disabled)
  }
}
